import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPersonne } from "./interface";


export interface IUtilisateurAppGestionInterneState {
  typeUtilisateurs: ITypeUtilisateur[];
  utilisateurs: IUtilisateur[];
  filteredUtilisateurs: IUtilisateur[];
  personnes: IPersonne[];
  agents: IPersonne[];
  droitsDesUtilisateurs: IDroitsDesUtilisateurs[];
}


export interface IDroit {
  idSousModuleDroit: string;
  idDroit: string;
  libDroit: string;
  descriptionDroit: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface IDroitsDesUtilisateurs {
  idDroit: string;
  idPersonne: number;
}

export interface ITypeUtilisateur {
  idTypeUtilisateur: number;
  libTypeUtilisateur: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface IUtilisateur {
  idPersonne: number | null;
  idTypeUtilisateur: number | null;
  email: string;
  passwordInitial?: string;
  createdAt?: string;
  updatedAt?: string;
  rights?: string
}

const initialState: IUtilisateurAppGestionInterneState = {
  typeUtilisateurs: [],
  utilisateurs: [],
  filteredUtilisateurs: [],
  personnes: [],
  agents: [],
  droitsDesUtilisateurs: [],
}

export const utilisateurAppGestionInterneSlice: any = createSlice({
  name: "utilisateurAppGestionInterne",
  initialState: initialState,

  reducers: {
    setTypeUtilisateur: (state, action: PayloadAction<ITypeUtilisateur[]>) => {
      state.typeUtilisateurs = action.payload;
    },

    setUtilisateur: (state, action: PayloadAction<IUtilisateur[]>) => {
      state.utilisateurs = action.payload;
    },

    deleteUtilisateur: (state, action: PayloadAction<number>) => {
      state.utilisateurs = state.utilisateurs.filter(u => u.idPersonne !== action.payload);
      state.filteredUtilisateurs = state.utilisateurs.filter(u => u.idPersonne !== action.payload);
    },

    addUtilisateur: (state, action: PayloadAction<any>) => {
      state.utilisateurs.unshift(action.payload.user);
      state.filteredUtilisateurs.unshift(action.payload.user);
    },

    editUtilisateur: (state, action: PayloadAction<IUtilisateur>) => {
      state.utilisateurs = state.utilisateurs.map(u => u.idPersonne === action.payload.idPersonne ? action.payload : u);
      state.filteredUtilisateurs = state.utilisateurs.map(u => u.idPersonne === action.payload.idPersonne ? action.payload : u);
    },

    setFilteredUtilisateur: (state, action: PayloadAction<IUtilisateur[]>) => {
      state.filteredUtilisateurs = action.payload;
    },

    setPersonne: (state, action: PayloadAction<IPersonne[]>) => {
      state.personnes = action.payload;
    },

    setAgents: (state, action: PayloadAction<IPersonne[]>) => {
      state.agents = action.payload;
    },

    setDroitsDesUtilisateurs: (state, action: PayloadAction<IDroitsDesUtilisateurs[]>) => {
      state.droitsDesUtilisateurs = action.payload;
    },

    updateDroitsDesUtilisateurs: (state, action: PayloadAction<any>) => {
      let updatedArray: any = [...state.droitsDesUtilisateurs]
      action.payload.rights.map((r: string) => {
        const index = state.droitsDesUtilisateurs
          .filter(du => du.idPersonne === action.payload.user.idPersonne)
          .findIndex(dua => dua.idDroit)
        if (index !== -1) {
          updatedArray[index] = { ...action.payload.user.idPersonne, idDroit: r }
        }
      })
      state.droitsDesUtilisateurs = [...updatedArray];
    },
  },
});

export const { deleteUtilisateur, updateDroitsDesUtilisateurs, editUtilisateur, setDroitsDesUtilisateurs, addUtilisateur, setAgents, setFilteredUtilisateur, setTypeUtilisateur, setUtilisateur, setPersonne } = utilisateurAppGestionInterneSlice.actions;

export default utilisateurAppGestionInterneSlice.reducer;
